module.exports = __webpack_public_path__ + "img/currents-compare.6cbf452.webp";